import React, {Component} from 'react';
import './styles/PageHeader.css';
import Button from '../../gadgets/Button';


class PageHeader extends Component {
    render() {
        const content = this.props.content;
        const link = content.link ?
            <Button notLocal={'true'} href={content.link.href} label={'find out more'}
                    color={'red-inverted'}/> : '';
        return (
            <div className={'header__container'}>
                <div className={`header header__background header__slant ${'header__background--' + this.props.color}`}>
                    <div className={'grid'}>
                        <div className={'col--5'}>
                            <h4 className={'text--white text--bold'}>{content.tag}</h4>
                            <h1 className={'text--white'}>{content.title}</h1>
                        </div>
                        <div className={'col--7 header__description'}>
                            <div className={'content__section text--white'}>
                                <p>{content.description}</p>
                                <br/>
                                {link}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PageHeader;